// src/components/common/NotificationToast.jsx
import React, { useEffect } from "react";
import { CheckCircle, AlertTriangle, X, Info, XCircle } from "lucide-react";

const icons = {
  success: CheckCircle,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
};

const colors = {
  success: "bg-green-500",
  error: "bg-red-500",
  warning: "bg-yellow-500",
  info: "bg-blue-500",
};

const NotificationToast = ({ id, type, message, duration = 5000, onClose }) => {
  const Icon = icons[type] || Info;
  const colorClass = colors[type] || colors.info;

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose(); // Ferme le toast automatiquement
      }, duration);
      return () => clearTimeout(timer); // Nettoyage au démontage
    }
  }, [duration, onClose]);

  return (
    <div
      className={`p-4 rounded-lg shadow-lg max-w-sm w-full transition-all duration-300 pointer-events-auto flex items-start space-x-4 ${colorClass} text-white transform translate-x-0 opacity-100`}
    >
      <div className="flex-shrink-0 pt-0.5">
        <Icon className="w-6 h-6" />
      </div>
      <div className="flex-1">
        <p className="font-semibold capitalize">{type}</p>
        <p className="text-sm mt-1">{message}</p>
      </div>
      <button
        onClick={onClose}
        className="p-1 rounded-full hover:bg-white/20 transition-colors flex-shrink-0 mt-0.5"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default NotificationToast;
